import { useUpdateAtom } from 'jotai/utils';
import { forwardRef } from 'react';
import SearchSection from '../SearchSection';
import { IconRadioCircle20, IconRadioEmptyCircle20 } from 'components/base/Icon';
import List from 'components/base/List';
import useSearchFilter from 'components/search/hooks/useSearchFilter';
import { set_free_shipping_atom } from 'components/search/store/searchSheet';

interface Props {}

/**
 * 검색 필터 - 색상 필터
 * @component
 */
const Delivery = forwardRef<HTMLElement, Props>((_, ref) => {
  const { delivery_list } = useSearchFilter();
  const setFreeShipping = useUpdateAtom(set_free_shipping_atom);
  const handleFreeShippingClick = (selected: boolean) => {
    setFreeShipping(selected);
  };

  //무료배송만 선 노출
  const delivery_list_by_filter = delivery_list.filter((item) => item.name === '무료배송');

  return (
    <SearchSection title='배송정보' use_line={false} ref={ref}>
      <List>
        {delivery_list_by_filter.map((item) => {
          return (
            <List.Item
              left={item.selected ? <IconRadioCircle20 /> : <IconRadioEmptyCircle20 />}
              key={item.name}
              title={item.name}
              title_style={
                item.selected
                  ? { variant: 'title5_medium', color: 'gray_active' }
                  : { variant: 'body2', color: 'gray_inactive' }
              }
              onClick={() => handleFreeShippingClick(!item.selected)}
            />
          );
        })}
      </List>
    </SearchSection>
  );
});

export default Delivery;
